import {createImgIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIMMenuGameOrientationController} from '../ui_html/main_page/header/UIMMenuGameOrientationController'
import {LobbyImage} from '@colonist/types'

export class UIMLandscapeDeprecationWarningPopup extends ViewPopup {
    constructor() {
        super({key: 'strings:popups.landscapeDeprecationWarning.title'},
            {key: 'strings:popups.landscapeDeprecationWarning.description'},
            () => UIMMenuGameOrientationController.togglePortraitMode(true),
            () => undefined,
            false, {
                xButtonCustomContent: {key: 'strings:popups.landscapeDeprecationWarning.cancelButton'},
                checkButtonCustomContent: {key: 'strings:popups.landscapeDeprecationWarning.okButton'},
            })
        this.xButton.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'
        createImgIn(this.body, LobbyImage.LandscapeDeprecationWarning, '')
    }

    show(): void {
        if(UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        super.show()
    }
}
